<div *ngIf="loginType !== 'CO' && showsearch" class="form search-form mb-0" (clickOutside)="clickOutside()">
    <div class="card mb-0">
        <div class="card-body p-1" id="search-tour">
            <div class="d-flex">
                <div class="input-group position-relative">
                    <span class="input-icon">
                        <img 
                            src="assets/images/Icons/searchIcon.png" 
                            (click)="executeSearch()" 
                            class="searchIcon" 
                            width="16px" 
                            alt="searchIcon" 
                            style="position: relative; left: 3px; cursor: pointer;">
                        
                        <!-- Search Input for Locations (when siteid !== 'ALL') -->
                        <input 
                            *ngIf="siteid !== 'ALL'"
                            class="w-20 search_deatail_input" 
                            type="text" 
                            [class.open]="open" 
                            [(ngModel)]="text"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder=Search
                            name="q" 
                            title="" 
                            autocomplete="off"
                            (focus)="onSearchFocus($event)"
                            (input)="onSearchInput(text)"
                            (keydown)="onSearchKeydown($event)">

                        <!-- Original Search Input (when siteid === 'ALL') -->
                        <input 
                            *ngIf="siteid === 'ALL'"
                            class="w-20 search_deatail_input" 
                            type="text" 
                            [class.open]="open" 
                            [(ngModel)]="text"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Search" 
                            name="q" 
                            title="" 
                            autocomplete="off" 
                            (keydown.enter)="searchbyshort(text)">
                    </span>
                </div>

                <!-- Dropdown Button -->
                @for(basicdropdownitem of basicDropdownData; track basicdropdownitem){
                <div class="btn-group" ngbDropdown>
                    <button 
                        class="btn {{basicdropdownitem.class}} dropdown-toggle btn-search" 
                        type="button"
                        ngbDropdownToggle>
                        {{basicdropdownitem.title}}
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu>
                        @for( basicData of basicdropdownitem.item; track basicData ){
                        <li>
                            <a 
                                class="dropdown-item" 
                                href="javascript:void(0)" 
                                ngbDropdownItem 
                                (click)="getData(basicData.list)">
                                {{basicData.list}}
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>
        </div>

        <!-- ✅ Location Suggestion Dropdown (for siteid !== 'ALL') -->
        <div 
            *ngIf="siteid !== 'ALL' && showLocationDropdown && filteredLocations.length > 0"
            class="location-suggestions-dropdown custom-scrollbar">
            @for(location of filteredLocations; track location.id; let i = $index){
            <div 
                class="location-suggestion-item"
                [class.selected]="selectedLocationIndex === i"
                (click)="selectLocation(location)">
                <div class="location-item-content">
                    <div class="location-unitno">
                        <strong>Unit No:</strong> {{ location.location_no || location.id }}
                    </div>
                    <div class="location-details" *ngIf="location.shortCode">
                        <small>Short Code: {{ location.shortCode }}</small>
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Empty State for Location Dropdown -->
        <div 
            *ngIf="siteid !== 'ALL' && showLocationDropdown && filteredLocations.length === 0 && text.trim() !== ''"
            class="location-suggestions-dropdown">
            <div class="empty-state">
                <p>No locations found matching "{{text}}"</p>
            </div>
        </div>
    </div>

    <!-- Original Menu Results Display -->
    @if(menuItems.length){
    <div class="Typeahead-menu custom-scrollbar" [class.is-open]="searchResult" id="search-outer" [class.open]="open">
        @for(menuItem of menuItems | slice : 0 : 8; track menuItem){
        <div class="ProfileCard u-cf">
            <div class="ProfileCard-details">
                <div class="ProfileCard-realName">
                    <div class="ProfileCard-avatar">
                        <app-svg-icon [icon]="menuItem.icon"></app-svg-icon>
                    </div>
                    <a [routerLink]="menuItem.path" class="realname" (click)="removeFix()">{{
                        menuItem.title }}</a>
                </div>
            </div>
        </div>
        }
    </div>
    }

    <div class="Typeahead-menu is-open" [class.is-open]="searchResultEmpty">
        <div class="tt-dataset tt-dataset-0">
            <div class="EmptyMessage">Opps!! There are no result found.</div>
        </div>
    </div>
</div>